import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './Landing.module.css';
import Header from '../../components/layout/Header/Header';
import HeroSection from './sections/HeroSection/HeroSection';
import FeaturesSection from './sections/FeaturesSection/FeaturesSection';
import AuditionsSection from './sections/AuditionsSection/AuditionsSection';
import SpotlightActorsSection from './sections/SpotlightActorsSection/SpotlightActorsSection';
import CTASection from './sections/CTASection/CTASection';
import Footer from '../../components/layout/Footer/Footer';
import { HERO_DATA } from '../../constants/landing';
import { useAuth } from '../../contexts/AuthContext';

const DASHBOARD_BY_ROLE = {
  TALENT: '/talent/dashboard',
  PRODUCER: '/producer/dashboard',
};

function LandingPage() {
  const navigate = useNavigate();
  const { isLoggedIn, role } = useAuth();
  const sectionRefs = useRef([]);

  useEffect(() => {
    const html = document.documentElement;
    html.style.overscrollBehaviorY = 'none';
    document.body.style.overscrollBehaviorY = 'none';
    return () => {
      html.style.overscrollBehaviorY = '';
      document.body.style.overscrollBehaviorY = '';
    };
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add(styles.sectionVisible);
          }
        });
      },
      { threshold: 0.12 }
    );
    sectionRefs.current.forEach(el => el && observer.observe(el));
    return () => observer.disconnect();
  }, []);

  const AUTH_ACTIONS = ['/signup', '/login', '/register'];

  const handleNavigate = (action) => {
    if (isLoggedIn && AUTH_ACTIONS.includes(action)) {
      navigate(DASHBOARD_BY_ROLE[role] ?? '/castings');
      return;
    }
    navigate(action);
  };

  const setRef = (i) => (el) => { sectionRefs.current[i] = el; };

  return (
    <div className={styles.landingPage}>
      <Header />
      <main className={styles.main}>
        <div ref={setRef(0)} className={`${styles.section} ${styles.sectionVisible}`}>
          <HeroSection data={HERO_DATA} onCTAClick={handleNavigate} />
        </div>
        <div ref={setRef(1)} className={styles.section}>
          <FeaturesSection />
        </div>
        <div ref={setRef(2)} className={styles.section}>
          <AuditionsSection
            onCardClick={(id) => navigate(`/castings/${id}`)}
            onViewAllClick={() => navigate('/castings')}
          />
        </div>
        <div ref={setRef(3)} className={styles.section}>
          <SpotlightActorsSection
            onCardClick={(id) => navigate(`/talents/${id}`)}
            onViewAllClick={() => navigate('/talents')}
          />
        </div>
        <div ref={setRef(4)} className={styles.section}>
          <CTASection
            onActorSignup={handleNavigate}
            onProducerSignup={handleNavigate}
          />
        </div>
      </main>
      <div style={{ scrollSnapAlign: 'none' }}>
        <Footer dark />
      </div>
    </div>
  );
}

export default LandingPage;
